// Form persistence keyed by route + field.
export function loadDraft(key) {
  try {
    const raw = localStorage.getItem(`scw:draft:${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveDraft(key, value) {
  try { localStorage.setItem(`scw:draft:${key}`, JSON.stringify(value)); } catch {}
}

export function clearDraft(key) {
  try { localStorage.removeItem(`scw:draft:${key}`); } catch {}
}

export function formatMytTimestamp(ts) {
  if (!ts) return "";
  return ts + " MYT";
}
